import DOMPurify from "dompurify";

export const richTextSx = {
    fontSize: 13,
    lineHeight: 1.7,
    wordBreak: "break-word",

    // ===== 基础块 =====
    "& p": {
        margin: "4px 0",
    },

    "& h1": {
        fontSize: "20px",
        fontWeight: 600,
        margin: "12px 0 6px",
    },

    "& h2": {
        fontSize: "18px",
        fontWeight: 600,
        margin: "10px 0 6px",
    },

    "& h3": {
        fontSize: "16px",
        fontWeight: 600,
        margin: "8px 0 4px",
    },

    "& h4, & h5, & h6": {
        fontSize: "14px",
        fontWeight: 600,
        margin: "6px 0 4px",
    },

    // ===== list（重点）=====
    "& ul, & ol": {
        paddingLeft: "1.4em",
        margin: "6px 0",
        listStylePosition: "inside",
    },

    "& li": {
        marginBottom: "4px",
    },

    // 嵌套 list
    "& li > ul, & li > ol": {
        marginTop: "2px",
    },

    // ===== 文本 =====
    "& strong": {
        fontWeight: 600,
    },

    "& em": {
        fontStyle: "italic",
    },

    "& u": {
        textDecoration: "underline",
    },

    "& del": {
        textDecoration: "line-through",
        color: "#888",
    },

    // ===== link =====
    "& a": {
        color: "#1976d2",
        textDecoration: "none",
        wordBreak: "break-all",
        "&:hover": {
            textDecoration: "underline",
        },
    },

    // ===== code =====
    "& code": {
        background: "#f1f5f9",
        padding: "2px 6px",
        borderRadius: "6px",
        fontSize: "12px",
        fontFamily: "monospace",
    },

    "& pre": {
        background: "#0f172a",
        color: "#e2e8f0",
        padding: "12px",
        borderRadius: "8px",
        overflowX: "auto",
        fontSize: "12px",
        lineHeight: 1.5,
    },

    "& pre code": {
        background: "transparent",
        padding: 0,
    },

    // ===== blockquote =====
    "& blockquote": {
        borderLeft: "3px solid #cbd5e1",
        paddingLeft: "10px",
        color: "#64748b",
        margin: "8px 0",
        fontStyle: "italic",
    },

    // ===== hr =====
    "& hr": {
        border: "none",
        borderTop: "1px solid #e5e7eb",
        margin: "12px 0",
    },

    // ===== table =====
    "& table": {
        width: "100%",
        borderCollapse: "collapse",
        margin: "8px 0",
        fontSize: "12px",
    },

    "& th": {
        border: "1px solid #e5e7eb",
        padding: "6px",
        background: "#f8fafc",
        fontWeight: 600,
        textAlign: "left",
    },

    "& td": {
        border: "1px solid #e5e7eb",
        padding: "6px",
    },

    // ===== image =====
    "& img": {
        maxWidth: "100%",
        borderRadius: "6px",
        margin: "6px 0",
    },

    // ===== inline elements reset =====
    "& span": {
        fontSize: "inherit",
        color: "inherit",
    },

    // ===== 防止奇怪嵌套 =====
    "& *:first-of-type": {
        marginTop: 0,
    },

    "& *:last-child": {
        marginBottom: 0,
    },
};

export const formatContent = (content = "") => {
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(content);

    if (isHtml) {
        return DOMPurify.sanitize(content);
    }

    // 👉 纯文本处理
    const clean = DOMPurify.sanitize(content, { ALLOWED_TAGS: [] });
    return clean.replace(/\n/g, "<br/>");
};


